import React, { FC } from "react";
import classNames from "classnames";
import { Input as InputAntd, InputProps } from "antd";

import { BemHelper } from "../../utils";

const bem = new BemHelper("input-protec");

export type Props = InputProps & { styleWrapper?: React.CSSProperties };

export const InputProtec: FC<Props> = ({
  prefix = " ",
  suffix = " ",
  styleWrapper = {},
  ...props
}) => {
  return (
    <div
      className={classNames([
        bem.block(),
        props.addonBefore && bem.modifier("start"),
        props.addonAfter && bem.modifier("end"),
      ])}
      style={styleWrapper}
    >
      <InputAntd
        {...props}
        prefix={prefix}
        suffix={suffix}
        status={props["aria-invalid"] ? "error" : undefined}
      />
    </div>
  );
};
